import * as bus from "@sinch/bus";
export const flagsConfigChangedListener = (callback) => bus.listen((flagConfigMessage) => callback(flagConfigMessage.payload), bus.isFlagsConfigChangedMessage);
